import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Box,
} from "@mui/material";

const CardComponent = ({
  id,
  tag,
  address,
  pincode,
  number,
  selectedAddress,
  setSelectedAddress,
}) => {
  const handleSelectAddress = (id) => {
    setSelectedAddress(id);
  };

  return (
    <Card
      key={id}
      variant="outlined"
      sx={{
        borderRadius: "30px",
        cursor: "pointer",
        border: selectedAddress === id ? "1px solid #FF8401" : "",
        backgroundColor: selectedAddress === id ? "#FFF6ED" : "",
        boxShadow:
          selectedAddress === id ? "rgba(0, 0, 0, 0.24) 0px 3px 8px" : "",
      }}
      onClick={() => handleSelectAddress(id)}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        padding={"5px"}
      >
        <Typography fontWeight={"bold"}>{tag}</Typography>
      </Box>
      <hr />
      <CardContent>
        <Typography>
          <span className="font-bold">Address: </span>
          {address} <span>-</span> <span>{pincode}</span>
        </Typography>
        <Typography>
          <span className="font-bold">Mobile: </span> {number}
        </Typography>
      </CardContent>
      <Box mt={"10px"}>
        <hr />
      </Box>
      <Box
        padding={"5px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Typography fontWeight={"bold"}>Select Address</Typography>
      </Box>
    </Card>
  );
};

export default CardComponent;
